import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';

import {
  copyMap,
  hardDeleteMap,
  insertMap,
  saveNewLayerOrderMap,
  saveNewBaseMapOrderMap,
  sendUserLocation,
  softDeleteMap,
  toggleSharedMap,
  toggleWithLocation,
  toggleWithLocationPrivate,
  toggleSharedPrivateMap,
  restoreMap,
  updateMap,
  updateMapLocationMap,
  updateMapVar,
  updateMapTemplate,
  updateMapBackgroundColor
} from './server/map-methods-server';

Meteor.methods({
  'maps.insert'(map, userId = this.userId) {
    return insertMap(map, userId);
  },
  'maps.update'(map) {
    return updateMap(map);
  },
  'maps.copy'(mapId) {
    return copyMap(mapId, this.userId);
  },
  'maps.softDelete'(mapId) {
    return softDeleteMap(mapId);
  },
  'maps.restore'(mapId) {
    return restoreMap(mapId);
  },
  'maps.sendUserLocation'(debugIP, userLocation) {
    return sendUserLocation(debugIP, userLocation);
  },
  'maps.hardDelete'(mapId) {
    return hardDeleteMap(mapId);
  },
  'maps.toggleShared'(mapId, isShared) {
    toggleSharedMap(mapId, isShared);
  },
  'maps.toggleSharedPrivate'(mapId, isShared) {
    toggleSharedPrivateMap(mapId, isShared);
  },
  'maps.toggleWithLocation'(mapId, isWithLocation) {
    toggleWithLocation(mapId, isWithLocation);
  },
  'maps.toggleWithLocationPrivate'(mapId, isWithLocationPrivate) {
    toggleWithLocationPrivate(mapId, isWithLocationPrivate);
  },
  'maps.saveNewLayerOrder'(mapId, layersArray) {
    saveNewLayerOrderMap(mapId, layersArray);
  },
  'maps.saveNewBaseMapOrderMap'(mapId, layersArray) {
    saveNewBaseMapOrderMap(mapId, layersArray);
  },
  'maps.updateMapLocation'(mapId, newMapLocation) {
    return updateMapLocationMap(mapId, newMapLocation);
  },
  'maps.updateMapTemplate'(mapId, newdata) {
    return updateMapTemplate(mapId, newdata);
  },
  'maps.updateMapVar'(mapId, newdata) {
    return updateMapVar(mapId, newdata);
  },
  'maps.updateBackgroundColor'(mapId, newBackgroundColor) {
    updateMapBackgroundColor(mapId, newBackgroundColor);
  }
});

rateLimit({
  methods: [
    'maps.insert',
    'maps.update',
    'maps.copy',
    'maps.softDelete',
    'maps.restore',
    'maps.hardDelete',
    'maps.toggleShared',
    'maps.toggleSharedPrivate',
    'maps.saveNewLayerOrder',
    'maps.updateMapLocation',
    'maps.updateMapVar',
    'maps.updateMapTemplate',
    'maps.updateBackgroundColor'
  ],
  limit: 5,
  timeRange: 1000
});
